var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.block)?_c('div',{staticClass:"block"},[_c(_vm.fieldType,{tag:"component",attrs:{"block":_vm.block}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }